/**
 * @generated SignedSource<<4410f950d8a22892078709c896e39805>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuSelection_Product$data = {
  readonly name: string;
  readonly productSkuSpecifications: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly values: ReadonlyArray<string>;
      };
    }>;
  };
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly _id: string;
        readonly id: string;
        readonly name: string;
        readonly variations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly name: string;
              readonly values: ReadonlyArray<string>;
            };
          }>;
        };
        readonly offers: {
          readonly edges: ReadonlyArray<{
            readonly __typename: string;
          }>;
        } | null;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuOtherOffers_Product">;
  readonly " $fragmentType": "ProductSkuSelection_Product";
};
export type ProductSkuSelection_Product$key = {
  readonly " $data"?: ProductSkuSelection_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuSelection_Product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "values",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuSelection_Product",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuSpecificationConnection",
      "kind": "LinkedField",
      "name": "productSkuSpecifications",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuSpecificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuSpecification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "_id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuVariationConnection",
                  "kind": "LinkedField",
                  "name": "variations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuVariationEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSkuVariation",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    }
                  ],
                  "concreteType": "ProductSkuOfferConnection",
                  "kind": "LinkedField",
                  "name": "offers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuOfferEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductSkuOtherOffers_Product"
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "0fbf0ecae3e4264c5faee78dc80af04b";

export default node;
